import React from 'react';

const SizeGuideModal = ({ isOpen, onClose, productType = 'remera' }) => {
  if (!isOpen) return null;

  const sizeGuides = {
    remera: {
      title: 'Guía de Talles - Remeras',
      tolerance: '± 2.5 cm',
      sizes: [
        { talla: 'S', ancho: '45.7', largo: '70.5' },
        { talla: 'M', ancho: '50.8', largo: '73.0' },
        { talla: 'L', ancho: '55.9', largo: '75.6' },
        { talla: 'XL', ancho: '61.0', largo: '78.1' },
        { talla: 'XXL', ancho: '66.0', largo: '80.6' },
        { talla: 'XXXL', ancho: '71.1', largo: '83.2' }
      ]
    },
    buzo: {
      title: 'Guía de Talles - Buzos',
      tolerance: '± 2.5 cm',
      sizes: [
        { talla: 'S', ancho: '50.8', largo: '68.6' },
        { talla: 'M', ancho: '55.9', largo: '71.1' },
        { talla: 'L', ancho: '61.0', largo: '73.7' },
        { talla: 'XL', ancho: '66.0', largo: '76.2' },
        { talla: 'XXL', ancho: '71.1', largo: '78.7' },
      ]
    },
    canguro: {
      title: 'Guía de Talles - Canguros',
      tolerance: '± 2.5 cm',
      sizes: [
        { talla: 'S', ancho: '50.8', largo: '68.6' },
        { talla: 'M', ancho: '55.9', largo: '71.1' },
        { talla: 'L', ancho: '61.0', largo: '73.7' },
        { talla: 'XL', ancho: '66.0', largo: '76.2' },
        { talla: 'XXL', ancho: '71.1', largo: '78.7' },
      ]
    }
  };

  const guide = sizeGuides[productType] || sizeGuides.remera;

  return (
    <div className="size-guide-overlay" onClick={onClose}>
      <div className="size-guide-modal" onClick={(e) => e.stopPropagation()}>
        <button className="size-guide-close" onClick={onClose}>
          <i className="fa-solid fa-times"></i>
        </button>

        <div className="size-guide-header">
          <i className="fa-solid fa-ruler"></i>
          <h3>{guide.title}</h3>
        </div>

        <div className="size-guide-body">
          <p className="size-guide-note">
            <i className="fa-solid fa-info-circle"></i>
            Todas las medidas están en centímetros. Tolerancia: <strong>{guide.tolerance}</strong>
          </p>

          <table className="size-guide-table">
            <thead>
              <tr>
                <th>Talla</th>
                <th>Ancho</th>
                <th>Largo</th>
              </tr>
            </thead>
            <tbody>
              {guide.sizes.map((size) => (
                <tr key={size.talla}>
                  <td className="talla-cell">{size.talla}</td>
                  <td>{size.ancho} cm</td>
                  <td>{size.largo} cm</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="size-guide-help">
            <p><strong>¿Cómo medir?</strong></p>
            <p><strong>Ancho:</strong> Medir de axila a axila con la prenda extendida.</p>
            <p><strong>Largo:</strong> Medir desde el hombro hasta el borde inferior.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SizeGuideModal;
